export const Colors: { [color: string]: string } = {
    PrimaryMain: '#00338E',
    PrimaryLight: '#335BA4',
    PrimarySelected: '#002363',
};
